import { createRouter, createWebHistory } from "vue-router";
import { RoleTypeEnum } from "../helpers/enum";
import { getPermission } from "@/utils/permissions";
import { getPortDetailPath } from "@/helpers/portDetail";

const DEFAULT_TITLE = "Urise | ";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "login",
      component: () => import("@/views/auth/Login.vue"),
      meta: {
        // guest: true,
        title: "Login",
      },
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/auth/Login.vue"),
      meta: {
        // guest: true,
        title: "Login",
      },
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: () => import("@/views/dashboard/Index.vue"),
      meta: {
        title: "Dashboard",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN, RoleTypeEnum.VIEWER],
      },
    },
    {
      path: "/dashboard-port",
      name: "dashboard-port",
      component: () => import("@/views/dashboard_port/Index.vue"),
      meta: {
        title: "Dashboard PORT",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN, RoleTypeEnum.VIEWER],
      },
    },
    {
      path: "/dashboard-port/detail",
      name: "dashboard-port/detail",
      redirect: (to) => ({
        path: getPortDetailPath(to.query.location || to.query.lokasi),
        query: to.query,
      }),
    },
    {
      path: "/dashboard-port/detail/cp",
      name: "dashboard-port/detail/cp",
      component: () => import("@/views/dashboard_port/detail/Index.vue"),
      meta: {
        title: "Detail PORT CP",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN, RoleTypeEnum.VIEWER],
      },
    },
    {
      path: "/dashboard-port/detail/north-stockpile",
      name: "dashboard-port/detail/north-stockpile",
      component: () => import("@/views/dashboard_port/detail/Index.vue"),
      meta: {
        title: "Detail NORTH-STOCKPILE",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN, RoleTypeEnum.VIEWER],
      },
    },
    {
      path: "/dashboard/detail",
      name: "dashboard/detail",
      component: () => import("@/views/dashboard/detail/Index.vue"),
      meta: {
        title: "Dashboard Detail",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN, RoleTypeEnum.VIEWER],
      },
    },
    {
      path: "/dashboard/detail/:date/:shift/:master_location",
      name: "dashboard/detail/filter",
      component: () => import("@/views/dashboard/detail/Index.vue"),
      meta: {
        title: "Dashboard Detail",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN, RoleTypeEnum.VIEWER],
      },
    },
    {
      path: "/user",
      name: "user",
      component: () => import("@/views/user/Index.vue"),
      meta: {
        title: "Kelola Pengguna",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN],
      },
    },
    {
      path: "/summary",
      name: "summary",
      component: () => import("@/views/summary/Index.vue"),
      meta: {
        title: "ROM Summary",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN, RoleTypeEnum.VIEWER],
      },
    },
    {
      path: "/port-summary",
      name: "port-summary",
      component: () => import("@/views/port_summary/Index.vue"),
      meta: {
        title: "Port Summary",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN, RoleTypeEnum.VIEWER],
      },
    },
    {
      path: "/live-tracking",
      name: "live-tracking",
      component: () => import("@/views/tracking/Index.vue"),
      meta: {
        title: "Pelacakan Langsung",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN, RoleTypeEnum.VIEWER],
      },
    },
    {
      path: "/pengaturan/shift",
      name: "pengaturan/shift",
      component: () => import("@/views/pengaturan/shift/Index.vue"),
      meta: {
        title: "Pengaturan Shift",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN],
      },
    },
    {
      path: "/pengaturan/anomaly",
      name: "pengaturan/anomaly",
      component: () => import("@/views/pengaturan/anomaly/Index.vue"),
      meta: {
        title: "Pengaturan Anomaly",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN],
      },
    },
    {
      path: "/pengaturan/init-stock-summary",
      name: "pengaturan/init-stock-summary",
      component: () =>
        import("@/views/pengaturan/init_stock_summary/Index.vue"),
      meta: {
        title: "Inisialisasi Stock Summary",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN],
      },
    },
    {
      path: "/pengaturan/manual-stock",
      name: "pengaturan/manual-stock",
      component: () => import("@/views/pengaturan/manual_stock/Index.vue"),
      meta: {
        title: "Manual Stock",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN],
      },
    },
    {
      path: "/pengaturan/ualert-configuration",
      name: "pengaturan/ualert-configuration",
      component: () =>
        import("@/views/pengaturan/ualert_configuration/Index.vue"),
      meta: {
        title: "Ualert Configuration",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN],
      },
    },
    {
      path: "/pengaturan/config-exclude",
      name: "pengaturan/config-exclude",
      component: () => import("@/views/pengaturan/config_exclude/Index.vue"),
      meta: {
        title: "Konfigurasi Exclude",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN],
      },
    },
    {
      path: "/pengaturan/config-threshold",
      name: "pengaturan/config-threshold",
      component: () => import("@/views/pengaturan/config_threshold/Index.vue"),
      meta: {
        title: "Konfigurasi Threshold",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN],
      },
    },
    {
      path: "/company",
      name: "company",
      component: () => import("@/views/company/Index.vue"),
      meta: {
        title: "Master Company",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN],
      },
    },
    {
      path: "/mst_group",
      name: "mst_group",
      component: () => import("@/views/mst_group/Index.vue"),
      meta: {
        title: "Master Group",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN],
      },
    },
    {
      path: "/mst_menu",
      name: "mst_menu",
      component: () => import("@/views/mst_menu/Index.vue"),
      meta: {
        title: "Master Menu",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN],
      },
    },
    {
      path: "/role",
      name: "role",
      component: () => import("@/views/role/Index.vue"),
      meta: {
        title: "Kelola Role & Menu",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN],
      },
    },
    {
      path: "/mst_rom",
      name: "mst_rom",
      component: () => import("@/views/mst_rom/Index.vue"),
      meta: {
        title: "Master ROM",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN],
      },
    },
    {
      path: "/mst_cp",
      name: "mst_cp",
      component: () => import("@/views/mst_cp/Index.vue"),
      meta: {
        title: "Master CP",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN],
      },
    },
    {
      path: "/rom-config",
      name: "rom-config",
      component: () => import("@/views/rom_config/Index.vue"),
      meta: {
        title: "ROM Config",
        requiresAuth: true,
      },
    },
    {
      path: "/mst_rom_track",
      name: "mst_rom_track",
      component: () => import("@/views/mst_rom_track/Index.vue"),
      meta: {
        title: "Master ROM Track",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN],
      },
    },
    {
      path: "/mst_cp_track",
      name: "mst_cp_track",
      component: () => import("@/views/mst_cp_track/Index.vue"),
      meta: {
        title: "Master CP Track",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN],
      },
    },
    {
      path: "/mst_langsiran",
      name: "mst_langsiran",
      component: () => import("@/views/mst_langsiran/Index.vue"),
      meta: {
        title: "Master Langsiran",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN],
      },
    },
    {
      path: "/level-permission",
      name: "level-permission",
      component: () => import("@/views/level_permission/Index.vue"),
      meta: {
        title: "Level Permission",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN],
      },
    },
    {
      path: "/log-activity",
      name: "activity_log",
      component: () => import("@/views/activity_log/Index.vue"),
      meta: {
        title: "Log Aktivitas",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN],
      },
    },
    {
      path: "/stock-transaction",
      name: "stock-transaction",
      component: () => import("@/views/stock_transaction/Index.vue"),
      meta: {
        title: "Stock Transaction",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN],
      },
    },
    {
      path: "/summary-stock",
      name: "summary-stock",
      component: () => import("@/views/summary_stock/Index.vue"),
      meta: {
        title: "Summary Stock",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN],
      },
    },
    {
      path: "/survey-stock",
      name: "survey-stock",
      component: () => import("@/views/survey_stock/Index.vue"),
      meta: {
        title: "Survey Stock",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN],
      },
    },
    {
      path: "/geofencing",
      name: "geofencing",
      component: () => import("@/views/geofencing/Index.vue"),
      meta: {
        title: "Geofencing",
        requiresAuth: true,
        access: [RoleTypeEnum.ADMIN, RoleTypeEnum.VIEWER],
      },
    },
    {
      path: "/callback",
      name: "callBack",
      component: () => import("@/views/auth/CallBack.vue"),
      meta: {
        title: "CallBack",
      },
    },
    {
      path: "/:catchAll(.*)",
      redirect: (to) => {
        const isAuthenticated = isTokenValid();
        if (isAuthenticated) {
          return { path: "/dashboard" };
        } else {
          return { path: "/login" };
        }
      },
    },
    {
      path: "",
      redirect: (to) => {
        const isAuthenticated = isTokenValid();
        if (isAuthenticated) {
          return { path: "/dashboard" };
        } else {
          return { path: "/login" };
        }
      },
    },
  ],
  //routes
});
router.afterEach((to, from) => {
  document.title = DEFAULT_TITLE + to.meta.title;
});
router.beforeEach(async (to, from, next) => {
  const isAuthenticated = isTokenValid();
  const role = getRole();

  // Jika halaman tidak memerlukan auth (login, callback, dll)
  if (!to.matched.some((record) => record.meta.requiresAuth)) {
    // Jika sudah login dan mencoba akses halaman public, arahkan ke dashboard
    if (isAuthenticated && (to.path === "/login" || to.path === "/")) {
      return next({ path: "/dashboard" });
    }
    return next();
  }

  // Halaman memerlukan auth
  if (!isAuthenticated) {
    return next({ path: "/login" });
  }

  // Dashboard adalah landing page, selalu allow access
  if (to.path === "/dashboard" || to.path.startsWith("/dashboard/")) {
    return next();
  }

  // Cek permission berdasarkan path route (tanpa leading slash)
  const routePath = to.path.replace(/^\//, "");
  const permission =
    getPermission(routePath) ||
    getPermission(to.name) ||
    (to.path.startsWith("/dashboard-port/detail")
      ? getPermission("dashboard-port/detail") ||
        getPermission("dashboard-port/detail/cp") ||
        getPermission("dashboard-port/detail/north-stockpile")
      : null);

  // Jika ada permission untuk route ini, cek can_read
  if (permission) {
    if (permission.can_read) {
      return next();
    } else {
      console.log(`Access denied to ${to.path} - can_read is false`);
      return next({ path: "/dashboard" });
    }
  }

  // Fallback ke role-based access jika tidak ada permission
  if (to.meta.access) {
    if (!to.meta.access.includes(role)) {
      return next({ path: "/dashboard" });
    }
    return next();
  }

  // Jika tidak ada permission dan tidak ada access, allow access
  return next();
});
function isTokenValid() {
  try {
    const token_urise = JSON.parse(localStorage.getItem("room_digitalization"));
    if (token_urise) {
      const tokenParts = token_urise.token.split(".");
      if (tokenParts.length !== 3) {
        throw new Error("Invalid token format");
      }

      const decodedToken = JSON.parse(atob(tokenParts[1]));
      const currentTime = Math.floor(Date.now() / 1000);

      if (decodedToken.exp >= currentTime) {
        return true;
      } else {
        localStorage.removeItem("room_digitalization");
        return false;
      }
    }
    return false;
  } catch (error) {
    localStorage.removeItem("room_digitalization");
    return false;
  }
}

function getRole() {
  const token_urise = JSON.parse(localStorage.getItem("room_digitalization"));
  if (token_urise) {
    return JSON.parse(token_urise.data.role_id);
  }
  return null;
}
export default router;
